import React from 'react';
import { Button, Row as TRow, Col } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { RoleUtils } from '@galaxy/lorule-react-commons';
import { ActionMemo } from '../../../api/actionMemoApiTypes';
import ApproversUpdateModal from '../modal/ApproversUpdateModal';
import ViewersUpdateModal from '../modal/ViewersUpdateModal';
import Approvers from './Approvers';
import Viewers from './Viewers';
import { AmStatusType } from '../../../utils/Constants';

interface ApproversViewersProps {
    amDetail: ActionMemo;
    refresh: () => void;
}

const ApproversViewers = (props: ApproversViewersProps) => {
    const { instance } = useMsal();
    const roles = RoleUtils.getRoles(instance);

    const {
        id: amId,
        amStatus,
        approvers,
        distributions: viewers,
        currentUserIsCreatorOrProjectManager,
        currentUserIsApprover,
    } = props.amDetail;
    const { autoApprove } = props.amDetail.template;

    const canEditApprovers =
        currentUserIsCreatorOrProjectManager ||
        currentUserIsApprover ||
        RoleUtils.checkRole(roles, ['ActionMemo.Admin']);

    return (
        <TRow className="mh-100">
            {!autoApprove && (
                <Col xl="6" className="py-2 px-3">
                    <div className="col-sm-12 accordion-sub-title border-bottom">
                        <div className="row row-page-header">
                            <div className="col-12 d-flex align-items-center my-2">
                                <h4 className="mr-auto text-weight-normal p-0 mt-2">Approvers</h4>

                                {canEditApprovers &&
                                    (amStatus === AmStatusType.Draft ||
                                        amStatus === AmStatusType.Pending ||
                                        amStatus === AmStatusType.Hold) && (
                                        <ApproversUpdateModal
                                            title="Update Approvers"
                                            toggleButton={
                                                <Button
                                                    variant="outline-primary ml-auto"
                                                    size="sm"
                                                    className="mobile-hide"
                                                >
                                                    <i className="far fa-edit" /> Update
                                                </Button>
                                            }
                                            amId={amId}
                                            amNumber={props.amDetail.amNumber}
                                            supNumber={props.amDetail.supNumber}
                                            approvers={approvers}
                                            refresh={props.refresh}
                                            creatorId={props.amDetail.amCreator}
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                    <Approvers
                        amId={amId}
                        amStatus={amStatus}
                        approvers={approvers}
                        refresh={props.refresh}
                    />
                </Col>
            )}
            <Col xl={!autoApprove ? 6 : 12} className="py-2 px-3">
                <div className="col-sm-12 accordion-sub-title border-bottom">
                    <div className="row row-page-header">
                        <div className="col-12 d-flex align-items-center my-2">
                            <h4 className="mr-auto text-weight-normal p-0 mt-2">Viewers</h4>

                            {(amStatus === AmStatusType.Draft ||
                                amStatus === AmStatusType.Pending ||
                                amStatus === AmStatusType.Hold ||
                                amStatus === AmStatusType.Approved) && (
                                <ViewersUpdateModal
                                    title="Update Viewers"
                                    toggleButton={
                                        <Button
                                            variant="outline-primary ml-auto"
                                            size="sm"
                                            className="mobile-hide"
                                        >
                                            <i className="far fa-edit" /> Update
                                        </Button>
                                    }
                                    amId={amId}
                                    amNumber={props.amDetail.amNumber}
                                    supNumber={props.amDetail.supNumber}
                                    viewers={viewers}
                                    refresh={props.refresh}
                                    creatorId={props.amDetail.amCreator}
                                    confidential={props.amDetail.confidential}
                                    currentUserIsCreatorOrProjectManager={
                                        currentUserIsCreatorOrProjectManager ||
                                        RoleUtils.checkRole(roles, ['ActionMemo.Admin'])
                                    }
                                />
                            )}
                        </div>
                    </div>
                </div>
                <Viewers viewers={viewers} />
            </Col>
        </TRow>
    );
};

export default ApproversViewers;
